import React from "react";
import { Instagram, Facebook, Mail, Phone, MessageCircle, MapPin } from "lucide-react";
import { Link } from "react-router-dom";
import Logo from "./Logo";

export default function Footer({ settings }) {
  const s = settings || {};
  return (
    <footer id="contato" className="relative bg-black border-t border-white/5 pt-20 pb-8" data-testid="site-footer">
      <div className="max-w-[1400px] mx-auto px-6">
        <div className="grid lg:grid-cols-12 gap-12">
          <div className="lg:col-span-5">
            <div className="mb-6">
              <Logo size={72} wordmarkClass="text-xl md:text-2xl" />
            </div>
            <p className="text-neutral-400 max-w-md leading-relaxed">
              Aluguel de simuladores profissionais para eventos corporativos, feiras, casamentos e experiências premium.
            </p>
            <div className="mt-8 flex items-center gap-3">
              <a href={`https://instagram.com/${(s.instagram || "").replace("@", "")}`} target="_blank" rel="noreferrer" className="w-10 h-10 rounded-full border border-white/10 hover:border-[#E31B23] hover:text-[#E31B23] flex items-center justify-center transition-colors" data-testid="footer-instagram">
                <Instagram className="w-4 h-4" />
              </a>
              <a href={`https://facebook.com/${(s.facebook || "").replace(/ /g, "")}`} target="_blank" rel="noreferrer" className="w-10 h-10 rounded-full border border-white/10 hover:border-[#008CFF] hover:text-[#008CFF] flex items-center justify-center transition-colors" data-testid="footer-facebook">
                <Facebook className="w-4 h-4" />
              </a>
              <a href={`https://wa.me/${(s.whatsapp || "").replace(/\D/g, "")}`} target="_blank" rel="noreferrer" className="w-10 h-10 rounded-full border border-white/10 hover:border-[#25D366] hover:text-[#25D366] flex items-center justify-center transition-colors" data-testid="footer-whatsapp">
                <MessageCircle className="w-4 h-4" />
              </a>
              <a href={`mailto:${s.email}`} className="w-10 h-10 rounded-full border border-white/10 hover:border-white hover:text-white flex items-center justify-center transition-colors" data-testid="footer-email">
                <Mail className="w-4 h-4" />
              </a>
            </div>
          </div>

          <div className="lg:col-span-3">
            <div className="overline text-white/60 mb-5">Links rápidos</div>
            <ul className="space-y-3 text-neutral-300">
              <li><a href="#simuladores" className="hover:text-[#E31B23] transition-colors">Simuladores</a></li>
              <li><a href="#galeria" className="hover:text-[#E31B23] transition-colors">Galeria</a></li>
              <li><a href="#eventos" className="hover:text-[#E31B23] transition-colors">Eventos</a></li>
              <li><a href="#depoimentos" className="hover:text-[#E31B23] transition-colors">Depoimentos</a></li>
              <li><Link to="/admin/login" className="hover:text-[#008CFF] transition-colors" data-testid="footer-admin-link">Painel administrativo</Link></li>
            </ul>
          </div>

          <div className="lg:col-span-4">
            <div className="overline text-white/60 mb-5">Contato</div>
            <ul className="space-y-4 text-neutral-300">
              <li className="flex items-center gap-3"><Phone className="w-4 h-4 text-[#E31B23]" /> {s.phone || "(15) 99999-9999"}</li>
              <li className="flex items-center gap-3"><MessageCircle className="w-4 h-4 text-[#25D366]" /> WhatsApp: {s.phone || "(15) 99999-9999"}</li>
              <li className="flex items-center gap-3"><Mail className="w-4 h-4 text-[#008CFF]" /> {s.email || "contato@simexperience.com.br"}</li>
              <li className="flex items-center gap-3"><MapPin className="w-4 h-4 text-white" /> {s.city || "Itu - SP"}</li>
            </ul>
            {s.map_embed_url && (
              <div className="mt-6 rounded-xl overflow-hidden border border-white/10 aspect-video">
                <iframe title="Mapa" src={s.map_embed_url} className="w-full h-full" allowFullScreen loading="lazy" />
              </div>
            )}
          </div>
        </div>

        <div className="race-line mt-14" />
        <div className="mt-6 flex flex-col md:flex-row items-center justify-between text-xs text-neutral-500 gap-4">
          <span>© {new Date().getFullYear()} SIM EXPERIENCE. Todos os direitos reservados.</span>
          <span className="font-mono-tech tracking-widest uppercase">Premium simulator experiences · Made with speed</span>
        </div>
      </div>
    </footer>
  );
}
